import {
  ThemeType,
} from '@toolify/server/src/services/UserSettingsService/strategies/ThemeUserSettingStrategy/enum/ThemeType'
import {IThemeVariables} from '@toolify/client/src/modules/theme/types/IThemeVariables'
import {DarkThemeVariables} from '@toolify/client/src/modules/theme/strategies/dark/DarkThemeVariables'
import {
  FiordNightThemeVariables,
} from '@toolify/client/src/modules/theme/strategies/fiord-night/FiordNightThemeVariables'
import {
  LightModernThemeVariables,
} from '@toolify/client/src/modules/theme/strategies/light-modern/LightModernThemeVariables'

export const ThemeTypeToThemeVariablesMap = new Map<ThemeType, IThemeVariables>([
  [ThemeType.Dark, DarkThemeVariables],
  [ThemeType.LightModern, LightModernThemeVariables],
  [ThemeType.FiordNight, FiordNightThemeVariables],
])
